export default __webpack_public_path__ + "static/media/NewYearResolution_15.b87736ae.png";